import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { UsersIcon } from "@heroicons/react/24/outline";
import { Breadcrumb } from "../../../components/Breadcrumb";

const EmployeeHierarchyOverrides: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const breadcrumbPages = [
    {
      name: "Admin",
      href: "#",
      current: false,
    },
    {
      name: "Manage",
      href: "#",
      current: false,
    },
    {
      name: "Hierarchy Overrides",
      href: "/admin/manage/employee-hierarchy-overrides",
      current: true,
      icon: (props: React.ComponentProps<"svg">) => (
        <UsersIcon
          {...props}
          className="w-6 h-6 text-primary-500 transition duration-75 group-hover:text-gray-900"
        />
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="xl:pl-0 flex-grow flex flex-col">
        <main className="flex-grow flex flex-col overflow-hidden">
          <div className="relative isolate overflow-hidden pt-6 flex-grow flex flex-col">
            <div className="mx-auto w-full px-4 sm:px-6 lg:px-8">
              {/* Breadcrumb */}
              <div className="mb-6">
                <Breadcrumb pages={breadcrumbPages} />
              </div>

              {/* Header */}
              <div className="mb-6">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Employee Hierarchy Overrides
                </h1>
                <p className="mt-2 text-sm text-gray-600">
                  Manage custom reporting structure overrides for specific
                  employees.
                </p>
              </div>

              {/* Content */}
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                {isLoading ? (
                  <div className="flex justify-center py-12">
                    <CircularProgress />
                  </div>
                ) : (
                  <div className="text-gray-500 text-center p-8 bg-gray-50 rounded-lg">
                    <UsersIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <p className="text-lg font-medium">Coming Soon</p>
                    <p className="text-sm">
                      Employee hierarchy override management functionality will
                      be available here.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default EmployeeHierarchyOverrides;
